export default new (class {
  doesSiteMatchesFilters(site, filters) {
    return (
      this._ownerMatches(site, filters) &&
      this._sunflowerSeedsMatches(site, filters) &&
      this._rapeSeedsMatches(site, filters) &&
      this._soyBeanMatches(site, filters) &&
      this._refiningMatches(site, filters) &&
      this._esterifyingMatches(site, filters) &&
      this._extractPressMatches(site, filters)
    );
  }

  _ownerMatches(site, filters) {
    if (filters.owner === null || filters.owner === undefined) {
      return true;
    } else {
      if (
        site.owner &&
        site.owner.toUpperCase() === filters.owner.toUpperCase()
      ) {
        return true;
      }
    }
    return false;
  }

  _sunflowerSeedsMatches(site, filters) {
    if (!filters.sunflowerSeeds) {
      return true;
    }

    let matches = false;
    if (typeof site.seeds === "object") {
      site.seeds.forEach(seed => {
        if (seed.type == "SUNFLOWER_SEED") {
          matches = true;
        }
      });
    }

    return matches;
  }

  _rapeSeedsMatches(site, filters) {
    if (!filters.rapeSeeds) {
      return true;
    }

    let matches = false;
    if (typeof site.seeds === "object") {
      site.seeds.forEach(seed => {
        if (seed.type == "RATE_SEED") {
          matches = true;
        }
      });
    }

    return matches;
  }

  _soyBeanMatches(site, filters) {
    if (!filters.soyBean) {
      return true;
    }

    let matches = false;
    if (typeof site.seeds === "object") {
      site.seeds.forEach(seed => {
        if (seed.type == "SOY_BEAN") {
          matches = true;
        }
      });
    }

    return matches;
  }

  _refiningMatches(site, filters) {
    if (!filters.refining) {
      return true;
    }

    let matches = false;
    if (
      typeof site.refining === "object" &&
      typeof site.refining.isRefining === "boolean"
    ) {
      matches = site.refining.isRefining;
    }

    return matches;
  }

  _esterifyingMatches(site, filters) {
    if (!filters.esterifying) {
      return true;
    }

    let matches = false;
    if (
      typeof site.esterification === "object" &&
      typeof site.esterification.isEsterifying === "boolean"
    ) {
      matches = site.esterification.isEsterifying;
    }

    return matches;
  }

  _extractPressMatches(site, filters) {
    if (filters.extractPress === null) {
      return true;
    } else {
      if (site.extract_press === filters.extractPress) {
        return true;
      }
    }
    return false;
  }
})();
